<template>
	<div class="home">
		<div class="top">
			<tabs @tabChange="initContent" :list="list">
				<div slot="current">

					<ul class="status">
						<li v-for="(item, index) in status" :key="index">
							<img :src="item.path" />
							<span :class="'index' + index">{{ item.status }}</span>
						</li>
					</ul>
					
					
					<van-pull-refresh v-model="isLoading1" @refresh="onRefresh1">
						<van-list>
							<van-cell>
								<div class="buildingLevel level1">
									<h3>一层平面图</h3>
									<div class="tables">
										<div class="layoutFlex">
											<div class="one">
												<ol>
													<li></li>
													<li>
														<div class="img"></div>
														<span class="index">115</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">112</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">109</span>
													</li>
													<li class="special">楼梯</li>
													<li>
														<div class="img"></div>
														<span class="index">107</span>
													</li>
													<li class="special">
														<div class="img"></div>
														<span class="index">105</span>
													</li>
												</ol>
											</div>
											<div class="two">走廊</div>
											<div class="three">
												<ol>
													<li>
														<div class="img"></div>
														<span class="index">113</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">111</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">110</span>
													</li>
													<li >
														<div class="img"></div>
														<span class="index">108</span>
													</li>
													<!-- <li v-if="item.childList.length == 14">
								  <div class="img1"></div>
								  <span class="index0">308</span>
								</li> -->
													<li class="special">门厅</li>
													<li>
														<div class="img"></div>
														<span class="index">106</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">103</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">102</span>
													</li>
												</ol>
											</div>
										</div>
										<div class="last">
											<div class="img"></div>
								
											<span class="index">101</span>
										</div>
									</div>
								</div>
							</van-cell>
							<van-cell>
								<div class="buildingLevel">
									<h3>二层平面图</h3>
									<div class="tables">
										<div class="layoutFlex">
											<div class="one">
												<ol>
													<li></li>
													<li>
														<div class="img"></div>
														<span class="index">215</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">212</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">209</span>
													</li>
													<li class="special">楼梯</li>
													<li>
														<div class="img"></div>
														<span class="index">207</span>
													</li>
													<li class="special">
														<div class="img"></div>
														<span class="index">205</span>
													</li>
												</ol>
											</div>
											<div class="two red">走廊</div>
											<div class="three">
												<ol>
													<li>
														<div class="img"></div>
														<span class="index">213</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">211</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">210</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">208</span>
													</li>
													<li class="special">门厅</li>
													<li>
														<div class="img"></div>
														<span class="index">206</span>
													</li>
													<li class="">
														<div class="img"></div>
														<span class="index">203</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">202</span>
													</li>
												</ol>
											</div>
										</div>
										<div class="last">
											<div class="img"></div>
											<span class="index">201</span>
										</div>
									</div>
								</div>
							</van-cell>
							<van-cell>
								<div class="buildingLevel">
									<h3>三层平面图</h3>
									<div class="tables">
										<div class="layoutFlex">
											<div class="one">
												<ol>
													<li></li>
													<li>
														<div class="img"></div>
														<span class="index">316</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">313</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">310</span>
													</li>
													<li class="special">楼梯</li>
													<li>
														<div class="img"></div>
														<span class="index">307</span>
													</li>
													<li class="special">
														<div class="img"></div>
														<span class="index">305</span>
													</li>
												</ol>
											</div>
											<div class="two">走廊</div>
											<div class="three">
												<ol>
													<li>
														<div class="img"></div>
														<span class="index">315</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">312</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">311</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">309</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">308</span>
													</li>
													<li class="red">门厅</li>
													<li>
														<div class="img"></div>
														<span class="index">306</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">303</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">302</span>
													</li>
												</ol>
											</div>
										</div>
										<div class="last">
											<div class="img"></div>
											<span class="index">301</span>
										</div>
									</div>
								</div>
							</van-cell>
							<van-cell>
								<div class="buildingLevel">
									<h3>四层平面图</h3>
									<div class="tables">
										<div class="layoutFlex">
											<div class="one">
												<ol>
													<li></li>
													<li>
														<div class="img"></div>
														<span class="index">416</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">413</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">410</span>
													</li>
													<li class="special">楼梯</li>
													<li>
														<div class="img"></div>
														<span class="index">407</span>
													</li>
													<li class="special">
														<div class="img"></div>
														<span class="index">405</span>
													</li>
												</ol>
											</div>
											<div class="two">走廊</div>
											<div class="three">
												<ol>
													<li>
														<div class="img"></div>
														<span class="index">415</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">412</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">411</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">409</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">408</span>
													</li>
													<li class="red">门厅</li>
													<li>
														<div class="img"></div>
														<span class="index">406</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">403</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">402</span>
													</li>
												</ol>
											</div>
										</div>
										<div class="last">
											<div class="img"></div>
											<span class="index">401</span>
										</div>
									</div>
								</div>
							</van-cell>
							<van-cell>
								<div class="buildingLevel">
									<h3>五层平面图</h3>
									<div class="tables">
										<div class="layoutFlex">
											<div class="one">
												<ol>
													<li></li>
													<li>
														<div class="img"></div>
														<span class="index">516</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">513</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">510</span>
													</li>
													<li class="special">楼梯</li>
													<li>
														<div class="img"></div>
														<span class="index">507</span>
													</li>
													<li class="special">
														<div class="img"></div>
														<span class="index">505</span>
													</li>
												</ol>
											</div>
											<div class="two">走廊</div>
											<div class="three">
												<ol>
													<li>
														<div class="img"></div>
														<span class="index">515</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">512</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">511</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">509</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">508</span>
													</li>
													<li class="red">门厅</li>
													<li>
														<div class="img"></div>
														<span class="index">506</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">503</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">502</span>
													</li>
												</ol>
											</div>
										</div>
										<div class="last">
											<div class="img"></div>
											<span class="index">501</span>
										</div>
									</div>
								</div>
							</van-cell>
							<van-cell>
								<div class="buildingLevel">
									<h3>六层平面图</h3>
									<div class="tables">
										<div class="layoutFlex">
											<div class="one">
												<ol>
													<li></li>
													<li>
														<div class="img"></div>
														<span class="index">616</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">613</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">610</span>
													</li>
													<li class="special">楼梯</li>
													<li>
														<div class="img"></div>
														<span class="index">607</span>
													</li>
													<li class="special">
														<div class="img"></div>
														<span class="index">605</span>
													</li>
												</ol>
											</div>
											<div class="two">走廊</div>
											<div class="three">
												<ol>
													<li>
														<div class="img"></div>
														<span class="index">615</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">612</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">611</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">609</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">608</span>
													</li>
													<li class="red">门厅</li>
													<li>
														<div class="img"></div>
														<span class="index">606</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">603</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">602</span>
													</li>
												</ol>
											</div>
										</div>
										<div class="last">
											<div class="img"></div>
											<span class="index">601</span>
										</div>
									</div>
								</div>
							</van-cell>
							<van-cell>
								<div class="buildingLevel">
									<h3>七层平面图</h3>
									<div class="tables">
										<div class="layoutFlex">
											<div class="one">
												<ol>
													<li></li>
													<li>
														<div class="img"></div>
														<span class="index">716</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">713</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">710</span>
													</li>
													<li class="special">楼梯</li>
													<li>
														<div class="img"></div>
														<span class="index">707</span>
													</li>
													<li class="special">
														<div class="img"></div>
														<span class="index">705</span>
													</li>
												</ol>
											</div>
											<div class="two">走廊</div>
											<div class="three">
												<ol>
													<li>
														<div class="img"></div>
														<span class="index">715</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">712</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">711</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">709</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">708</span>
													</li>
													<li class="red">门厅</li>
													<li>
														<div class="img"></div>
														<span class="index">706</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">703</span>
													</li>
													<li>
														<div class="img"></div>
														<span class="index">702</span>
													</li>
												</ol>
											</div>
										</div>
										<div class="last">
											<div class="img"></div>
											<span class="index">701</span>
										</div>
									</div>
								</div>
							</van-cell>
						</van-list>
					</van-pull-refresh>	
					<!-- //楼层平面图开始 -->
					
					
					
					
					
					
					
					<div style="height: 40px"></div>
				</div>
				<div slot="history">
					<div class="currentPre" @click="show = true">
						<div style="width: 80%; text-align: center">
							<div v-if="!isShow" class="place">
								<span>入住日期</span>
								<span>-</span>
								<span>离开日期</span>
							</div>
							<div v-else class="fontss">{{ date }}</div>
						</div>

						<van-icon name="calendar-o" />
					</div>
					<van-calendar allow-same-day v-model="show" type="range" :min-date="minDate" :max-date="maxDate"
						@confirm="onConfirm" />
					<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
						<div class="autoFixed">
							<van-list v-model="loading" :finished="finishedBottom" finished-text="没有更多了" @load="onLoad">
								<van-cell v-for="(item, index) in histroyLists" :key="index"
									style="margin-bottom: 20px; padding: 0">
									<div class="main">
										<span class="roomName">{{ item.roomInfo }}</span>
										<div class="history-left" style="margin-top: 20px;">
											<div class="history-item"  v-if="item.appointmentStatus==1||item.appointmentStatus==9||item.appointmentStatus==4">
												<span>入住时间：</span>
												<span>{{ item.entryTime }}</span>
											</div>
											<div class="history-item" v-if="item.appointmentStatus!=1&&item.appointmentStatus!=9&&item.appointmentStatus!=4">
												<span>入住时间：</span>
												<span>{{ item.checkinTime==null?'':item.checkinTime }}</span>
											</div>
											 
											<div class="history-item" v-if="item.appointmentStatus==1||item.appointmentStatus==9||item.appointmentStatus==4">
												<span>离开时间：</span>
												<span >{{ item.leaveTime }}</span>
											</div>
											<div class="history-item" v-if="item.appointmentStatus!=1&&item.appointmentStatus!=9&&item.appointmentStatus!=4">
												<span>离开时间：</span>
												<span >{{ item.checkoutTime==null?'':item.checkoutTime }}</span>
											</div>
											<div class="history-item">
												<span>预约时间：</span>
												<span>{{ item.createTime }}</span>
											</div>
										</div>
										<div class="hisotry-right">
											<img v-if="item.appointmentStatus == 1" src="../assets/sushe/yuyuezhong.png"
												alt="" />
											<img v-if="item.appointmentStatus == 2" src="../assets/sushe/ruzhuzhong.png"
												alt="" />
											<img v-if="item.appointmentStatus == 5" src="../assets/sushe/yiwancheng.png"
												alt="" />
											<img v-if="item.appointmentStatus == 3" src="../assets/sushe/tuifang.png"
												alt="" />
											<img v-if="item.appointmentStatus == 4" src="../assets/sushe/weiyue.png"
												alt="" />
											<img v-if="item.appointmentStatus == 9" src="../assets/sushe/quxiao.png"
												alt="" />
										</div>

										<van-button plain type="info" size="small" class="userBtn"
											@click="cancleRooms(item)" v-if="item.appointmentStatus == 1">取消
										</van-button>
										<van-button plain type="info" size="small" class="userBtn"
											@click="checkout(item)" v-if="item.appointmentStatus == 2">评价
										</van-button>
										<van-button plain type="info" size="small" class="userBtn userBtns"
											@click="repaire(item)" v-if="item.appointmentStatus == 2">报修
										</van-button>
										<!-- <div class="userBtn">取消</div> -->
										<!-- <div class="userBtn">退房</div> -->
									</div>
								</van-cell>
								<!-- 加载的内容-->
							</van-list>

						</div>
					</van-pull-refresh>
				</div>
			</tabs>
		</div>
		<!-- 退房弹窗 -->
		<div class="checkout" v-if="isShowtuifang">
			<div class="checkoutContent">
				<van-field v-model="messages" rows="2" autosize label="评价" type="textarea" maxlength="50"
					placeholder="请输入留言" show-word-limit />
				<div style="margin-top: 40px;">
					<span style="margin-right: 10px;">上传图片</span>
					<van-uploader :after-read="afterRead" :max-count="4" v-model="fileList" class="uploader">
						<!-- <span>点击调用摄像头进行拍摄</span> -->
					</van-uploader>
				</div>
				<div style="text-align: center;margin-top: 30px;">
					<van-button round type="info" size="normal" @click="submitComment">提交评论</van-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import tabs from "../components/tabs.vue";
	import {
		getRoomsList,
		roomHistory,
		addRoom,
		cancelRoom,
		roomCheckout,
		upLoadPicture,
		submitComments
	} from "../apis/api";
	import {
		Toast,
		Dialog
	} from "vant";
	import {
		formatTime
	} from "../utils/index";
	export default {
		data() {
			return {
				messages: '',
				isShowtuifang: false,
				show: false,
				fileList: [],
				date: "",
				minDate: new Date(2000, 0, 1),
				maxDate: new Date(2030, 0, 31),
				list: [{
						name: "当前预约",
						type: "current",
					},
					{
						name: "历史预约",
						type: "history",
					},
				],
				isShow: false,
				roomLists: [],
				level1: "",
				showConfirm: false,
				status: [{
						status: "已入住",
						path: require("../assets/sushe/ruzhu.png"),
					},
					{
						status: "已预约",
						path: require("../assets/sushe/yuyue.png"),
					},
					{
						status: "锁定",
						path: require("../assets/sushe/suoding.png"),
					},
					{
						status: "可预约",
						path: require("../assets/sushe/keyuyue.png"),
					},
				],
				entryTime: "",
				leaveTime: "",
				pageNo: 1,
				pageSize: 3,
				isLoading: false,
				isLoading1:false,
				count: 0,
				currentTabIndex: "",
				histroyLists: [],
				loading: false,
				finishedBottom: false,
				total: 0,
				setTimer: null,
				ids: '',
				roomsId:'',
				uploadList:[]
			};
		},
		beforeDestroy() {
			clearInterval(this.setTimer)
			this.setTimer = null;
		},
		mounted() {
			document.title = "宿舍预约";
			this.getRoomsLists();
			let _this = this;
			this.$nextTick(() => {
				// document.addEventListener('touchmove', function(e) {
				//     e.preventDefault();
				//   }, { passive: false });
				this.$(".tables li").click(function() {
					let status = _this.$(this).attr("status");
					let ids = _this.$(this).attr("id");
					let nums = _this.$(this).find('.index').html();
					
					// console.log()
					// <!-- 0 空闲  1：已预约，234都是入住中  9冻结 -->
					if (status == 0) {
						_this.$router.push({
							path:'/addRoom',
							query:{
								roomNum:nums,
								id:ids
							}
						})
					} else if (status == 1) {
						Toast("该房间已被预约");
					} else if (status == 9) {
						Toast("该房间已锁定");
					} else {
						Toast("该房间已被入住");
					}
				});
				this.$(".tables .last").click(function() {
					let status = _this.$(this).attr("status");
					let ids = _this.$(this).attr("id");
					let nums = _this.$(this).find('.index').html();
					console.log(status,'_this.date',_this.date)
					// <!-- 0 空闲  1：已预约，234都是入住中  9冻结 -->
					if (status == 0) {
						_this.$router.push({
							path:'/addRoom',
							query:{
								roomNum:nums,
								id:ids
							}
						})
					} else if (status == 1) {
						Toast("该房间已被预约");
					} else if (status == 9) {
						Toast("该房间已锁定");
					} else {
						Toast("该房间已被入住");
					}
				});
			});
		},

		methods: {
			onRefresh1(){
				
				this.getRoomsLists();
				this.isLoading1 = false
			},
			repaire(item){
				this.ids = item.id;
				this.roomsId = item.roomId
				Dialog.confirm({
						title: '提醒',
						message: '是否提交报修',
					})
					.then(() => {
						// on confirm
						// this.isShowtuifang = true;
						this.$router.push({path:'/repaire',query:{
							id:item.id,
							roomId:item.roomId
						}})
					})
					.catch(() => {
						// 取消
						// roomCheckout({
						// 	id: item.id,
						// 	openId: localStorage.getItem("openId"),
						// 	roomId: item.roomId
						// }).then(res => {
						// 	Dialog({
						// 		message: "退房成功"
						// 	});
						// 	this.pageNo = 1;
						// 	this.getHistoryLists()
						// })
						// on cancel
					});
			},
			submitComment() {
				submitComments({
					appointmentId: this.ids,
					photoList: this.uploadList,
					userComment: this.messages
				}).then(res => {
					this.$toast("提交成功")
					this.isShowtuifang = false;
					roomCheckout({
						id: this.ids,
						openId: localStorage.getItem("openId"),
						roomId: this.roomsId
					}).then(xhr => {
						Dialog({
							message: "取消成功"
						});
						this.pageNo = 1;
						this.getHistoryLists()
					})
				})
			},
			afterRead(file) {
				console.log(file);
				file.status = 'uploading';
				file.message = '上传中...';
				this.uploadList.push(file.content)
				upLoadPicture({
					img: file.content,
					openId: localStorage.getItem('openId'),
					ext: file.file.name.split('.')[1]
				}).then(res => {
					console.log(res)
					Toast('上传成功')
					this.personImg = res.result.savePath;
					file.status = 'done';
					file.message = '上传成功';
				})
			},

			// 退房
			checkout(item) {
				console.log(item, '==')
				this.ids = item.id;
				this.roomsId = item.roomId
				Dialog.confirm({
						title: '提醒',
						message: '是否提交评价',
					})
					.then(() => {
						// on confirm
						// this.isShowtuifang = true;
						this.$router.push({path:'/comments',query:{
							id:item.id,
							roomId:item.roomId
						}})
					})
					.catch(() => {
						// 取消
						// roomCheckout({
						// 	id: item.id,
						// 	openId: localStorage.getItem("openId"),
						// 	roomId: item.roomId
						// }).then(res => {
						// 	Dialog({
						// 		message: "退房成功"
						// 	});
						// 	this.pageNo = 1;
						// 	this.getHistoryLists()
						// })
						// on cancel
					});

			},
			onLoad() {
				console.log("加载更多");
				this.pageNo++;
				roomHistory({
					openId: localStorage.getItem("openId"),
					entryTime: this.entryTime,
					leaveTime: this.leaveTime,
					pageNo: this.pageNo,
					pageSize: this.pageSize,
				}).then((res) => {
					// Toast("刷新成功");
					this.isLoading = false;
					this.loading = false;
					this.histroyLists = this.histroyLists.concat(res.result.records);
					if (this.histroyLists.length == this.total) {
						this.finishedBottom = true;
					}

				});
				this.finishedBottom = true;
			},
			cancleRooms(item) {
				//   this.showConfirm = true;
				console.log(item);

				Dialog.confirm({
						title: "提示",
						message: "确认取消吗？",
					})
					.then(() => {
						// on confirm
						cancelRoom({
							id: item.id,
							openId: localStorage.getItem("openId"),
							roomId: item.roomId,
						}).then((res) => {
							console.log(res,'+++')
							Toast(res.message);
							if(res.code!=200){
								
							}else{
								window.location.reload();
							}
							// 
						});
					})
					.catch(() => {
						// on cancel
					});
			},
			onRefresh() {
				this.pageNo = 1;
				this.pageSize = 10;
				roomHistory({
					openId: localStorage.getItem("openId"),
					entryTime: this.entryTime,
					leaveTime: this.leaveTime,
					pageNo: this.pageNo,
					pageSize: this.pageSize,
				}).then((res) => {
					Toast("刷新成功");
					this.isLoading = false;
					this.loading = false;
					this.finishedBottom = false;
					this.histroyLists = res.result.records;
					this.total = res.result.total;
					console.log("history", res);
				});
			},
			getRoomsLists() {
				getRoomsList({
					openId: localStorage.getItem("openId")
				}).then((res) => {
					this.roomLists = res.result;
					
					// this.level1 = this.roomLists[0].childList[0];
					// 首先处理one下的li
					if (this.roomLists != null && this.roomLists.length) {
						this.roomLists[0].childList.forEach((items, index) => {
							console.log(items);
							items.childList.forEach((iiitem, idx) => {
								this.$nextTick(() => {
									this.$(".index").each((index, item) => {
										if (this.$(item).html() == iiitem
											.roomName) {
											console.log(iiitem.roomStatus);
											this.$(item).parent("li").attr(
												"status", iiitem.roomStatus);
											this.$(item).parent("li").attr("id",
												iiitem.roomId);
											this.$(item)
												.parent(".last")
												.attr("status", iiitem.roomStatus);
												this.$(item)
													.parent(".last")
													.attr("id", iiitem.roomId);
											//   <!-- 0 空闲  1：已预约，234都是入住中  9冻结 -->
											if (iiitem.roomStatus == 1) {
												this.$(item).parent("li").addClass(
													"statusTwo");
												this.$(item).parent(".last")
													.addClass("statusTwo");
											} else if (iiitem.roomStatus == 0) {
												this.$(item).parent("li").addClass(
													"statusOne");
													this.$(item).parent("li").removeClass('statusTwo statusFour')
												this.$(item).parent(".last")
													.addClass("statusOne");
												this.$(item).parent(".last").removeClass('statusTwo statusFour')
											} else if (iiitem.roomStatus == 9) {
												this.$(item).parent("li").addClass(
													"statusThree");
												this.$(item).parent(".last")
													.addClass("statusThree");
											} else {
												this.$(item).parent("li").addClass(
													"statusFour");
												this.$(item).parent(".last")
													.addClass("statusFour");
											}
										}
									});
								});
							});
						});
					}

				});
			},
			beforeDay(num) {
				//设置日期，当前日期的前num天
				var myDate = new Date(); //获取今天日期
				// myDate.setDate(myDate.getDate() - (num - 1));
				var dateArray = [];

				var dateTemp;
				var flag = 1;
				dateTemp =
					(myDate.getFullYear() - 1) +
					"-" +
					(myDate.getMonth() + 1) +
					"-" +
					myDate.getDate();
				dateArray.push(dateTemp);
				myDate.setDate(myDate.getDate() + flag);
				return dateArray;
			},
			initContent(value) {
				// debugger;
				this.currentTabIndex = value;
				if (value == 0) {
					this.isShow = false;
					this.date = "";
					this.entryTime = "";
					this.leaveTime = "";
					// this.pageSize = 10;
					// this.pageNo =1;
					// 刷新页面
				} else {
					this.date = "";
					this.isShow = false;
					console.log(this.beforeDay(1), '==========');
					this.entryTime = this.beforeDay(1)[0] + " " + '00:00:00';
					this.leaveTime = formatTime() + " " + '23:59:59';
					this.pageSize = 10;
					this.pageNo = 1;
					this.getHistoryLists();
				}
			},
			getHistoryLists() {
				roomHistory({
					openId: localStorage.getItem("openId"),
					entryTime: this.entryTime,
					leaveTime: this.leaveTime,
					pageNo: this.pageNo,
					pageSize: this.pageSize,
				}).then((res) => {
					console.log("history", res);
					this.histroyLists = res.result.records;
					this.total = res.result.total;
				});
			},
			formatDate(date) {
				return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			},
			onConfirm(date) {
				console.log(date, "==========");
				const [start, end] = date;
				this.show = false;
				this.isShow = true;
				this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
				this.entryTime = this.formatDate(start);
				this.leaveTime = this.formatDate(end);
				if (this.currentTabIndex == 1) {
					this.pageNo = 1;
					this.getHistoryLists();
				}
				console.log(this.date);
			},
		},
		components: {
			tabs,
		},
	};
</script>

<style lang="less" scoped>
	.checkout {
		height: 100vh;
		background: rgba(0, 0, 0, .5);
		width: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 100;

	}

	.checkoutContent {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 80%;
		height: 40vh;
		background: #FFFFFF;
		border-radius: 10px;
		padding: 20px;
		box-sizing: border-box;

	}

	.modals {
		width: 90%;
		height: 30vh;
		padding: 20px;
	}

	.aufoCenter {
		width: 100vh;
		width: 100%;
		text-align: center;
	}

	.home {
		background: #f7f7f7;
		min-height: 100vh;

		.place {
			display: flex;
			align-items: center;
			justify-content: center;
		}

		// padding: 20px;
		.top {
			// background-color:#489FFF;
			width: 100%;
			min-height: 100vh;
			overflow-y: scroll;
		}

		.currentPre {
			display: flex;
			height: 80px;
			align-items: center;
			width: 80%;
			margin: 0 auto;
			border: 2px solid #7ab6f5;
			margin-top: 20px;
			border-radius: 40px;
			justify-content: center;
			background-color: #ffffff;
			margin-bottom: 20px;

			span {
				font-size: 32px;
				color: #7ab6f5;
				margin-right: 20px;
			}

			.fontss {
				font-size: 32px;
				color: #7ab6f5;
				margin-right: 20px;
			}

			i {
				font-size: 40px;
				color: #7ab6f5;
			}
		}

		.status {
			display: flex;
			margin-top: 20px;
			padding-bottom: 20px;
			padding-top: 20px;
			border-bottom: 1px solid #ccc;
			border-top: 1px solid #ccc;

			li {
				flex: 1;
				text-align: center;
				height: 60px;
				display: flex;
				align-items: center;
				justify-content: center;

				img {
					width: 40px;
					height: 40px;
					margin-right: 10px;
				}

				span {
					font-size: 28px;
				}

				.index1 {
					color: #64b0ff;
				}

				.index2 {
					color: #db2212;
				}

				.index3 {
					color: #009700;
				}

				.index0 {
					color: #bfbfbf;
				}
			}
		}

		h3 {
			text-align: center;
			background: #489fff;
			margin: 0;
			margin-top: 20px;
			height: 80px;
			line-height: 80px;
			color: #ffffff;
			font-size: 32px;
		}

		.buildingLevel {
			padding: 0 20px;
			margin-bottom: 20px;
		}

		.tables {
			width: 100;
			background: #ffffff;
			// padding:0 20px;
			// border: 1px solid #ccc;
			// background: blue;
			display: flex;
			border: 1px solid #ccc;

			// box-shadow: 0px 0px 5px #999;
			.layoutFlex {
				// display: flex;
				width: 100%;

				.one {
					width: 100%;
					height: 80px;

					ol {
						list-style: none;
						display: flex;
						height: 100%;
						width: 100%;

						li {
							width: 11.11%;
							// line-height: 80px;
							text-align: center;
							border-bottom: 1px solid #ccc;
						}
					}
				}

				.two {
					height: 80px;
					// width: 100%;
					text-align: center;
					line-height: 80px;
					border-right: 1px solid #ccc;
					color: red;
					// border-left: 1px solid #ccc;
					font-size: 24px;
				}

				.three {
					height: 80px;
					width: 100%;

					ol {
						list-style: none;
						display: flex;
						width: 100%;
						height: 100%;

						li {
							width: 11.11%;
							// line-height: 80px;
							text-align: center;
							border-top: 1px solid #ccc;
						}
					}
				}
			}

			.last {
				width: 13%;
				// border: 1px solid #ccc;
				border-left: none;
				text-align: center;
				// line-height: 240px;
				display: flex;
				align-items: center;
				flex-direction: column;
				justify-content: center;

				// height: 100%;
				span {
					font-size: 24px;
				}
			}
		}
	}

	.special {
		width: 22.22% !important;
		color: red;
		font-size: 24px;
	}

	.red {
		color: red;
		font-size: 24px;
		// font-weight:bold;
	}

	ol {
		li {
			border-right: 1px solid #ccc;
			// &:last-child{
			// 	border-right: none;
			// }
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			.index1 {
				color: #64b0ff;
				font-size: 24px;
			}

			.index2 {
				color: #db2212;
				font-size: 24px;
			}

			.index3 {
				color: #009700;
				font-size: 24px;
			}

			.index0 {
				color: #bfbfbf;
				font-size: 24px;
			}
		}
	}

	.statusOne {
		color: #009700;

		.img {
			background: url(../assets/sushe/keyuyue.png) no-repeat;
			background-size: 100% 100%;
			height: 35px;
			width: 35px;
			margin-top: 8px;
		}
	}

	.statusOne {
		color: #009700;

		.img {
			background: url(../assets/sushe/keyuyue.png) no-repeat;
			background-size: 100% 100%;
			height: 35px;
			width: 35px;
			margin-top: 8px;
		}
	}

	.statusTwo {
		color: #64b0ff;

		.img {
			background: url(../assets/sushe/yuyue.png) no-repeat;
			background-size: 100% 100%;
			height: 35px;
			width: 35px;
			margin-top: 8px;
		}
	}

	.statusThree {
		color: #db2212;

		.img {
			background: url(../assets/sushe/suoding.png) no-repeat;
			background-size: 100% 100%;
			height: 35px;
			width: 35px;
			margin-top: 8px;
		}
	}

	.statusFour {
		color: #bfbfbf;

		.img {
			background: url(../assets/sushe/ruzhu.png) no-repeat;
			background-size: 100% 100%;
			height: 35px;
			width: 35px;
			margin-top: 8px;
		}
	}

	.img1 {
		background: url(../assets/sushe/ruzhu.png) no-repeat;
		background-size: 100% 100%;
		height: 35px;
		width: 35px;
		margin-top: 8px;
	}

	.img2 {
		background: url(../assets/sushe/yuyue.png) no-repeat;
		background-size: 100% 100%;
		height: 35px;
		margin-top: 8px;
		width: 35px;
	}

	.img3 {
		background: url(../assets/sushe/suoding.png) no-repeat;
		background-size: 100% 100%;
		height: 35px;
		width: 35px;
		margin-top: 8px;
	}

	.img4 {
		background: url(../assets/sushe/keyuyue.png) no-repeat;
		background-size: 100% 100%;
		height: 35px;
		width: 35px;
		margin-top: 8px;
	}

	.autoFixed {
		padding: 30px;
		padding-bottom: 0;
		padding-top: 0;
		position: relative;

		.userBtn {
			position: absolute;
			right: 20px;
			top: 20px;
			width: 94px;
			height: 40px;
			text-align: center;
			line-height: 40px;

			background: none;
			border-radius: 5px;
			color: #4597FF;
		}
		.userBtns{
			right: 130px;
		}
		.main {
			background: #ffffff;
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			border-radius: 5px;
			padding: 30px;
			box-sizing: border-box;
			position: relative;
			padding-top: 60px;
			padding-bottom: 0;

			// margin-bottom: 20px;
			.roomName {
				position: absolute;
				left: 20px;
				top: 20px;
				color: #64b0ff;
				font-weight: bold;
			}

			.hisotry-right {
				img {
					width: 150px;
					height: 130px;
				}
			}

			.history-item {
				margin-bottom: 20px;

				span {
					font-size: 28px;
					color: #333;
				}
			}
		}
	}
</style>
